const CITATION_GROUP = /\s*\((?:(?:sweep|lib|library)\s+)?\[[A-Z]?\d{1,3}\]\([^)\s]+\)(?:\s*[,;]\s*(?:(?:sweep|lib|library)\s+)?\[[A-Z]?\d{1,3}\]\([^)\s]+\))*\)/g;
const CITATION_MARKER = /\s*\[[A-Z]?\d{1,3}\]\([^)\s]+\)/g;

export function deepResearchSpokenText(report: string): string {
  return report.replace(CITATION_GROUP, "").replace(CITATION_MARKER, "").trim();
}
